// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#loader[data-v-523f0e36]{width:100vw;height:100vh;background-color:#212121;display:flex;flex-flow:column;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
